import React from 'react';
import { Icon } from '.';

export const IconCheckedCircle = props => {
  return (
    <Icon color="GREEN" {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          fill="GREEN"
          stroke="none"
          d="
           M 12.00,0.00
           C 5.38,0.00 0.00,5.38 0.00,12.00
             0.00,18.62 5.38,24.00 12.00,24.00
             18.62,24.00 24.00,18.62 24.00,12.00
             24.00,5.38 18.62,0.00 12.00,0.00
             12.00,0.00 12.00,0.00 12.00,0.00 Z
           M 9.60,18.00
           C 9.60,18.00 3.60,12.00 3.60,12.00
             3.60,12.00 5.29,10.31 5.29,10.31
             5.29,10.31 9.60,14.60 9.60,14.60
             9.60,14.60 18.71,5.50 18.71,5.50
             18.71,5.50 20.40,7.20 20.40,7.20
             20.40,7.20 9.60,18.00 9.60,18.00
             9.60,18.00 9.60,18.00 9.60,18.00 Z"
        />
      </svg>
    </Icon>
  );
};
